"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpanderTriggerButton = exports.ClickableRow = exports.CardCol = void 0;

var _card = require("../card");

var _context = require("../context");

var _helpers = require("../helpers");

var _layout = require("../layout");

var _utils = require("../utils");

var _constants = require("./constants");

var CardCol = _card.Card.withComponent(_layout.Col, {
  target: "edbdntt0"
});

exports.CardCol = CardCol;
var ClickableRow = (0, _context.styledWithTheme)(_layout.Row)({
  cursor: 'pointer'
});
exports.ClickableRow = ClickableRow;
var ExpanderTriggerButton = (0, _context.styledWithTheme)(_helpers.TriggerButton)(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    color: selectors.color(_constants.HEADER_COLOR),
    ':focus': {
      borderColor: 'transparent',
      outline: 'none'
    },
    ':hover,:active': {
      borderColor: selectors.color(_constants.HEADER_COLOR)
    },
    ':focus-visible': {
      outlineColor: selectors.color('primary70'),
      outline: "".concat((0, _utils.px)(_constants.FOCUS_OUTLINE_WIDTH), " solid ").concat(selectors.color(_constants.FOCUS_COLOR)),
      outlineOffset: (0, _utils.px)(_constants.FOCUS_OUTLINE_OFFSET)
    }
  };
});
exports.ExpanderTriggerButton = ExpanderTriggerButton;